import MarkdownIt from 'markdown-it'
import DOMPurify from 'dompurify'

export { renderMarkdown, renderInlineMarkdown, MARKDOWN_TYPOGRAPHY }

// Authored content relies on inline HTML (<b>, <br>, <sup>, <sub>), so raw HTML has to pass
// through markdown-it — which is why everything it produces is sanitized before use.
const md = new MarkdownIt({ html: true })

const renderLinkOpen = md.renderer.rules.link_open ??
  ((tokens, idx, options, _env, self) => self.renderToken(tokens, idx, options))

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  tokens[idx].attrSet('target', '_blank')
  return renderLinkOpen(tokens, idx, options, env, self)
}

// DOMPurify strips `target` by default, which would undo the link_open rule above.
const sanitize = (html: string) => DOMPurify.sanitize(html, { ADD_ATTR: ['target'] })

function renderMarkdown(text: string): string {
  return sanitize(md.render(text))
}

function renderInlineMarkdown(text: string): string {
  return sanitize(md.renderInline(text))
}

// Tailwind's preflight strips heading sizes and list markers, which authored markdown
// depends on. These restore them at fixed sizes, so headings don't scale with the surrounding text.
const MARKDOWN_TYPOGRAPHY = [
  '[&_img]:max-w-full',
  '[&_p]:mb-2.5',
  '[&_:is(h1,h2,h3,h4,h5,h6)]:font-medium [&_:is(h1,h2,h3,h4,h5,h6)]:mb-2.5',
  '[&_:is(h1,h2,h3)]:mt-5 [&_:is(h1,h2,h3)]:leading-[1.3] [&_:is(h4,h5,h6)]:mt-2.5',
  '[&_h1]:text-display-lg [&_h2]:text-display-md [&_h3]:text-display-sm [&_h4]:text-xl [&_h5]:text-md [&_h6]:text-sm',
  '[&_:is(ul,ol)]:mb-2.5 [&_:is(ul,ol)]:pl-10 [&_ul]:list-disc [&_ol]:list-decimal',
].join(' ')
